exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-tooltip[data-v-3891489c] {\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n\ttransition: opacity 0.2s ease;\n}\n.color-block[data-v-3891489c] {\n\twidth: 20px;\n\theight: 20px;\n\tborder-radius: 3px;\n\tdisplay: inline-block;\n\tmargin-right: 5px;\n}\n", ""]);

// exports
